var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopWaves(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 763,
    height: 653,
    viewBox: "0 0 763 653",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5712 698C-1.22399 643.278 -1.74388 526.231 162.538 495.817C367.891 457.8 347.096 374.853 360.093 312.643C373.09 250.433 370.49 37.0173 554.181 86.267C701.134 125.667 754.624 44.5056 763 -1",
    stroke: "#6B7B8E",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.479 700C116.324 651.048 117.673 546.87 260.303 521.773C438.59 490.403 426.387 415.612 435.473 360.072C444.559 304.532 445.2 123.06 600.681 159.268C726.481 187.51 771.907 122.127 780 87",
    stroke: "#6B7B8E",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopWaves);
export default __webpack_public_path__ + "static/media/top-waves.2ebab5c97cff38fe5be6da7a43e638d4.svg";
export { ForwardRef as ReactComponent };